import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import type { ChartData, ChartOptions } from "chart.js";
import { generateDynamicChartColors } from "../../utils/generateDynamicChartColors";

interface DynamicLineChartProps {
  labels: string[];
  data: number[];
  dataTitle: string;
  seed?: number;
}

export const DynamicLineChart: React.FC<DynamicLineChartProps> = ({
  labels,
  data,
  dataTitle,
  seed = 0
}) => {
  const chartOptions: ChartOptions<"line"> = {
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        labels: {
          color: "white"
        }
      },
      datalabels: {
        color: "white",
        display: true,
        formatter: (value: any) => value,
        font: {
          weight: "bold" as "bold"
        }
      }
    },
    scales: {
      x: {
        ticks: {
          color: "white"
        },
        grid: {
          display: false
        }
      },
      y: {
        ticks: {
          color: "white"
        },
        grid: {
          color: "rgba(255,255,255,0.2)"
        }
      }
    },
    hover: {
      mode: undefined
    }
  };

  const chartData = useMemo<ChartData<"line">>(() => {
    const { backgroundColors, borderColors } = generateDynamicChartColors(data.length, seed);
    return {
      labels,
      datasets: [
        {
          label: dataTitle,
          data,
          fill: false,
          backgroundColor: backgroundColors[0], // Utilizando a primeira cor para os pontos
          borderColor: borderColors[0],
          borderWidth: 2,
          tension: 0.4
        }
      ]
    };
  }, [labels, data, dataTitle, seed]);

  return <Line data={chartData} options={chartOptions} />;
};

export default DynamicLineChart;
